import Swal from 'sweetalert2'

export function normalizeCustomToastText(value) {
  return String(value ?? '').replace(/<br\s*\/?\s*>/gi, '\n')
}

export function showCustomSwalToast({
  text = '',
  confirmButtonText,
  preConfirm,
  showConfirmButton = Boolean(confirmButtonText),
  persistOnNavigation = false,
  swal = Swal,
} = {}) {
  const fireOptions = {
    icon: null,
    text: normalizeCustomToastText(text),
    width: 'auto',
    background: '#414458',
  }

  if (typeof preConfirm === 'function') {
    fireOptions.preConfirm = preConfirm
  }

  return swal.mixin({
    toast: true,
    customClass: {
      popup: persistOnNavigation ? 'my-custom-toast route-persistent-toast' : 'my-custom-toast',
      htmlContainer: 'my-custom-text',
      actions: 'my-custom-actions',
      confirmButton: 'my-custom-confirm-button',
    },
    showClass: { popup: 'animate__animated animate__fadeInDown' },
    hideClass: { popup: 'animate__animated animate__fadeOutUp' },
    position: 'top',
    showConfirmButton,
    ...(confirmButtonText ? { confirmButtonText } : {}),
    showCloseButton: false,
    timer: 8000,
    timerProgressBar: false,
    didOpen: toast => {
      toast.addEventListener('mouseenter', swal.stopTimer)
      toast.addEventListener('mouseleave', swal.resumeTimer)
    },
  }).fire(fireOptions)
}
